import React from "react";
import { FaReact, FaCss3Alt } from "react-icons/fa";
import { RiHtml5Line } from "react-icons/ri";
import { IoLogoJavascript } from "react-icons/io";
import { GrNode } from "react-icons/gr";
import { SiRedux } from "react-icons/si";
import Slider from "react-slick/lib/slider";
import styled from "styled-components";

const icons = [
  <RiHtml5Line className="icons" style={{ color: "#da4722a9" }} />,
  <FaCss3Alt className="icons" style={{ color: "#164fee90" }} />,
  <IoLogoJavascript className="icons" style={{ color: "#e7e30086" }} />,
  <FaReact className="icons" style={{ color: "#1dcde490" }} />,
  <GrNode className="icons" style={{ color: "#14d6026f" }} />,
  <SiRedux className="icons" style={{ color: "#e41db290" }} />,
];

const Logos = () => {
  const settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 3,
    arrows: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  };

  const logoMap = icons.map((icon, i) => <div key={i}>{icon}</div>);
  return (
    <Contents>
      <Slider {...settings} style={{ marginTop: "4rem" }}>
        {logoMap}
      </Slider>
    </Contents>
  );
};

export default Logos;

const Contents = styled.div`
  .icons {
    font-size: 3rem;
    opacity: 0.7;
    :hover {
      opacity: 1;
    }
  }
  @media (max-width: 970px) {
    margin-bottom: 2rem;
  }
  .slick-track {
    text-align: center;
  }
`;
